/**
 * 全局调参中心。修改这里即可不动业务逻辑改观感。
 */
export const config = {
  scene: {
    cameraFov: 65,
    cameraNear: 0.1,
    cameraFar: 200,
    cameraPosition: [0, 0, 5] as [number, number, number],
    backgroundColor: '#0c0a09',
  },
  cube: {
    size: 1.3,
    autoRotateSpeed: 0.005,
    dragRotateSensitivity: 0.005,
    inertiaDecayMs: 500,
    /** 立方体被允许移动的 AABB（收紧到弧内，避免穿出胶片带） */
    bounds: {
      x: [-3.0, 3.0] as [number, number],
      y: [-3.0, 3.0] as [number, number],
      z: [-2.5, 2.5] as [number, number],
    },
    returnDelayMs: 1000,
    returnDurationMs: 1500,
    followLerp: 0.2,
  },
  filmstrip: {
    /** 半圆柱半径（米） */
    radius: 4.0,
    /** 弧起始角与弧长（弧度）。270° 居中 -z，避免转头时看到弧端 */
    thetaStart: Math.PI * 0.25,
    thetaLength: Math.PI * 1.5,
    /** 半圆柱高度（米），即每条 band 的视觉厚度 */
    bandHeight: 1.5,
    /** 用户提供的源帧数 */
    frameSources: 12,
    /** 相机视野内同屏可见帧数（实际 repeat.x = 此值 × arcDeg / fovDeg / frameSources ≈ 1） */
    visibleFramesPerArc: 1,
    bands: [
      {
        id: 'top' as const,
        y: 2.0,
        /** UV 单位每秒；为正即沿贴图 U+ 方向滚动 */
        scrollSpeed: 0.04,
        scrollDirection: -1 as 1 | -1,
        blurPx: 0,
      },
      {
        id: 'middle' as const,
        y: 0,
        scrollSpeed: 0.025,
        scrollDirection: 1 as 1 | -1,
        blurPx: 0,
      },
      {
        id: 'bottom' as const,
        y: -2.0,
        scrollSpeed: 0.05,
        scrollDirection: 1 as 1 | -1,
        blurPx: 0,
      },
    ],
  },
  dropBox: {
    /** 中心位置（米） */
    position: [0, -1.8, 1.5] as [number, number, number],
    /** 正方形 plane 边长（米） */
    side: 1.2,
    /** 围绕 X 轴的仰角（度） */
    tiltDeg: 45,
    /** 横向重叠占 cube footprint 的最低比例（0..1） */
    lateralRatio: 0.3,
    /** prox 渐亮起点距离（米）：cube 距 plane > approachDist 时几乎不亮 */
    approachDist: 0.8,
    /** Label 文字 */
    label: '拖入此处 → 主站',
  },
  head: {
    /** EMA 平滑系数 */
    emaAlpha: 0.25,
    /** 相机视差权重 */
    cameraYawWeight: 0.3,
    cameraPositionXWeight: 0.4,
    cameraPitchWeight: 0.15,
    /** 相机插值速度 */
    cameraLerp: 0.15,
  },
  hand: {
    pinchEnter: 0.04,
    pinchExit: 0.07,
    emaAlpha: 0.35,
    emaAlphaZ: 0.15,
    mapping: {
      mirrorX: true,
      /** 与 cube.bounds 对齐（收紧到弧内） */
      xRange: [-3.0, 3.0] as [number, number],
      yRange: [-3.0, 3.0] as [number, number],
      zCenter: 0,
      zScale: 2.0,
      zRange: [-2.5, 2.5] as [number, number],
    },
  },
  input: {
    cubeInertiaDecayPerFrame: 0.92,
  },
  tracking: {
    visionWasmBase: 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.18/wasm',
    faceModel:
      'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task',
    handModel:
      'https://storage.googleapis.com/mediapipe-models/hand_landmarker/hand_landmarker/float16/1/hand_landmarker.task',
    videoWidth: 640,
    videoHeight: 480,
    faceMinIntervalMs: 33,
    handMinIntervalMs: 33,
  },
  assets: {
    paths: {
      background: '/assets/backgrounds/scene-main.webp',
      backgroundVideo: '/assets/backgrounds/scene-main.mp4',
      cubeModel: '/assets/models/cube.glb',
      dropBoxTexture: '/assets/ui/dropbox/wall.webp',
      faceTexture: (i: number) => `/assets/textures/face-${i}.webp`,
      filmFrame: (band: 'top' | 'middle' | 'bottom', i: number) =>
        `/assets/filmstrips/${band}/frame-${String(i + 1).padStart(2, '0')}.webp`,
    },
  },
} as const

export type BandId = 'top' | 'middle' | 'bottom'
